import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

import './assets/typora-lark.css'

Vue.config.productionTip = false

axios.interceptors.request.use(config => {
  config.withCredentials = true;
  return config;
});
Vue.prototype.$axios = axios

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
